export const mockPosts = [
  {
    id: "1",
    user: "Jessica Martinez",
    username: "@jessicam",
    avatar: "https://public.readdy.ai/ai/img_res/c360520252fdefb48850e6caae953e5d.jpg",
    role: "influencer",
    platform: "tiktok",
    followers: "2.3M",
    content: "Just got my order from TechVision Factory and WOW the quality is insane! These earbuds are literally better than AirPods at half the price. Link in bio to grab yours! #LocalMade #TechDeals #StarBookPrime",
    image: "https://readdy.ai/api/search-image?query=young%20woman%20holding%20wireless%20earbuds%20smiling%20lifestyle%20photo%20indoor%20bright%20room%20natural%20light&width=680&height=400&seq=post1&orientation=landscape",
    likes: 18420,
    comments: 934,
    shares: 2103,
    time: "2h ago",
    tagged: ["prod1"],
    type: "product",
    earned: "$840",
    tag: "Electronics",
  },
  {
    id: "2",
    user: "Marcus Johnson",
    username: "@marcusj_life",
    avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20smiling%20portrait%20casual%20outdoor%20natural%20light&width=80&height=80&seq=user2&orientation=squarish",
    role: "user",
    platform: "instagram",
    followers: "45K",
    content: "Sunday morning vibes with the family! Life is beautiful when you have time to enjoy the little things. Grateful for every moment. This is what it's all about — family, love, and good food. 🌟",
    image: "https://readdy.ai/api/search-image?query=happy%20family%20outdoor%20picnic%20sunny%20day%20park%20green%20grass%20children%20laughing%20warm%20lifestyle%20photo&width=680&height=400&seq=post2&orientation=landscape",
    likes: 3241,
    comments: 187,
    shares: 412,
    time: "4h ago",
    tagged: [],
    type: "life",
    earned: null,
    tag: null,
  },
  {
    id: "3",
    user: "Sarah Chen",
    username: "@sarahchen_beauty",
    avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20beauty%20influencer%20portrait%20professional%20makeup%20glowing%20skin&width=80&height=80&seq=user3&orientation=squarish",
    role: "influencer",
    platform: "youtube",
    followers: "890K",
    content: "Full skincare routine using only products from verified factories on StarBookPrime! The PureGlow Vitamin C serum has completely transformed my skin in just 3 weeks. Honest review video is up now! Sharing this to my 890K YouTube fans — already earned $1,200 in commissions this month! #Skincare #EarnMore",
    image: "https://readdy.ai/api/search-image?query=skincare%20products%20flat%20lay%20arrangement%20serums%20moisturizers%20clean%20white%20marble%20background%20beauty%20lifestyle&width=680&height=400&seq=post3&orientation=landscape",
    likes: 24891,
    comments: 1203,
    shares: 3401,
    time: "6h ago",
    tagged: ["prod4"],
    type: "product",
    earned: "$1,200",
    tag: "Beauty",
  },
  {
    id: "4",
    user: "Lily Chen",
    username: "@lily_tiktok",
    avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20influencer%20portrait%20smiling%20natural%20makeup%20warm%20tone&width=80&height=80&seq=user-lily&orientation=squarish",
    role: "influencer",
    platform: "tiktok",
    followers: "890K",
    content: "My TikTok fashion haul from verified factories went viral! 2.1M views and my family's grocery bill is covered for the whole year. Thank you StarBookPrime! Share more, earn more — this is real! 💛",
    image: "https://readdy.ai/api/search-image?query=woman%20showing%20fashion%20clothing%20haul%20colorful%20outfits%20lifestyle%20indoor%20bright%20studio%20background&width=680&height=400&seq=post-lily&orientation=landscape",
    likes: 94200,
    comments: 5200,
    shares: 12400,
    time: "8h ago",
    tagged: ["prod5"],
    type: "product",
    earned: "$4,800",
    tag: "Fashion",
  },
  {
    id: "5",
    user: "Amanda Rivera",
    username: "@amandacooks",
    avatar: "https://readdy.ai/api/search-image?query=latina%20woman%20cooking%20food%20blogger%20portrait%20kitchen%20background%20warm%20smile&width=80&height=80&seq=user5&orientation=squarish",
    role: "user",
    platform: "instagram",
    followers: "28K",
    content: "Made my grandma's tamale recipe this Sunday! The whole family gathered around the kitchen — these are the moments I live for. Life is so much sweeter when shared with the people you love. 🫶",
    image: "https://readdy.ai/api/search-image?query=home%20cooking%20kitchen%20scene%20family%20gathering%20warm%20cozy%20interior%20food%20preparation%20together%20happy&width=680&height=400&seq=post5&orientation=landscape",
    likes: 5621,
    comments: 298,
    shares: 743,
    time: "12h ago",
    tagged: [],
    type: "life",
    earned: null,
    tag: null,
  },
  {
    id: "6",
    user: "James Thompson",
    username: "@james_youtube",
    avatar: "https://readdy.ai/api/search-image?query=young%20man%20confident%20smile%20portrait%20casual%20outdoor%20natural%20light&width=80&height=80&seq=user-james&orientation=squarish",
    role: "influencer",
    platform: "youtube",
    followers: "128K",
    content: "Unboxed these factory-direct gadgets for my YouTube channel — 128K subscribers went crazy! Commission check incoming. If you have fans on YouTube, TikTok, or Instagram — start sharing verified factory products today. Together we earn more for our families! 🙌",
    image: "https://readdy.ai/api/search-image?query=man%20unboxing%20electronics%20gadgets%20YouTube%20review%20setup%20desk%20professional%20lighting%20studio&width=680&height=400&seq=post-james&orientation=landscape",
    likes: 21000,
    comments: 874,
    shares: 3200,
    time: "1d ago",
    tagged: ["prod2"],
    type: "product",
    earned: "$1,240",
    tag: "Electronics",
  },
  {
    id: "7",
    user: "Tyler Brooks",
    username: "@tylerbrooks_fit",
    avatar: "https://readdy.ai/api/search-image?query=athletic%20man%20fitness%20trainer%20portrait%20gym%20background%20confident%20smile&width=80&height=80&seq=user4&orientation=squarish",
    role: "user",
    platform: "instagram",
    followers: "62K",
    content: "Morning run with my daughter — she's getting so fast! These are the moments that make everything worth it. Life is good when you slow down and enjoy it. 🌅",
    image: "https://readdy.ai/api/search-image?query=father%20daughter%20morning%20run%20jogging%20park%20sunrise%20happy%20lifestyle%20outdoor%20fitness%20family&width=680&height=400&seq=post7&orientation=landscape",
    likes: 9823,
    comments: 567,
    shares: 1892,
    time: "1d ago",
    tagged: [],
    type: "life",
    earned: null,
    tag: null,
  },
];

export const mockStories = [
  { id: "1", user: "Your Story", avatar: "", isAdd: true },
  { id: "2", user: "Jessica M.", avatar: "https://readdy.ai/api/search-image?query=young%20woman%20smiling%20portrait%20warm%20lighting&width=56&height=56&seq=story1&orientation=squarish", isAdd: false },
  { id: "3", user: "Marcus J.", avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20smiling%20casual%20outdoor&width=56&height=56&seq=story2&orientation=squarish", isAdd: false },
  { id: "4", user: "Sarah C.", avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20beauty%20portrait%20professional&width=56&height=56&seq=story3&orientation=squarish", isAdd: false },
  { id: "5", user: "Lily C.", avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20influencer%20portrait%20smiling&width=56&height=56&seq=story4&orientation=squarish", isAdd: false },
  { id: "6", user: "Amanda R.", avatar: "https://readdy.ai/api/search-image?query=latina%20woman%20cooking%20food%20blogger%20portrait&width=56&height=56&seq=story5&orientation=squarish", isAdd: false },
  { id: "7", user: "James T.", avatar: "https://readdy.ai/api/search-image?query=young%20man%20confident%20smile%20portrait%20casual&width=56&height=56&seq=story6&orientation=squarish", isAdd: false },
];

export const topEarners = [
  { name: "Lily Chen", handle: "@lily_tiktok", platform: "tiktok", followers: "890K", earned: "$4,800", avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20influencer%20portrait%20smiling%20natural%20makeup&width=60&height=60&seq=earn1&orientation=squarish" },
  { name: "Sarah Chen", handle: "@sarahchen_beauty", platform: "youtube", followers: "890K", earned: "$1,200", avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20beauty%20influencer%20portrait%20professional%20makeup&width=60&height=60&seq=earn2&orientation=squarish" },
  { name: "James Thompson", handle: "@james_youtube", platform: "youtube", followers: "128K", earned: "$1,240", avatar: "https://readdy.ai/api/search-image?query=young%20man%20confident%20smile%20portrait%20casual%20outdoor&width=60&height=60&seq=earn3&orientation=squarish" },
  { name: "Jessica Martinez", handle: "@jessicam", platform: "tiktok", followers: "2.3M", earned: "$840", avatar: "https://readdy.ai/api/search-image?query=young%20woman%20smiling%20portrait%20professional%20headshot%20warm%20lighting&width=60&height=60&seq=earn4&orientation=squarish" },
];
